import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import useIsDesktop from 'reservations/base/hooks/useIsDesktop';
import { BOX_SHADOW_NORMAL } from 'reservations/brand/constants';

const Image = styled('img')({
  position: 'relative',
  height: '100%',
  width: '100%',
  objectFit: 'contain'
});

type LogoProps = {
  src: string;
  alt: string;
  dataTestId?: string;
  logoLinkPath?: string;
};

function Logo({ src, alt, dataTestId, logoLinkPath }: LogoProps) {
  // TODO: Remove as part of RES-1634
  // istanbul ignore next
  const isDesktop = useIsDesktop();
  // istanbul ignore next
  const logoSize = isDesktop ? '180px' : '130px';

  return (
    <Button href={logoLinkPath} sx={{ zIndex: 1, backgroundColor: 'inherit' }}>
      <Paper
        data-testid="logo-wrapper"
        sx={{
          height: logoSize,
          width: logoSize,
          overflow: 'hidden',
          borderRadius: '4px',
          boxShadow: BOX_SHADOW_NORMAL
        }}
      >
        <Image src={src} alt={alt} data-testid={dataTestId} />
      </Paper>
    </Button>
  );
}

export default Logo;
